import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import ButtonBase from '@sorare/core/src/atoms/buttons/ButtonBase';
import { LabelM } from '@sorare/core/src/atoms/typography';
import VerifyPhoneNumber from '@sorare/core/src/components/user/VerifyPhoneNumber';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { glossary } from '@sorare/core/src/lib/glossary';

const Root = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--unit);
  border-radius: var(--double-and-a-half-unit);
  padding: var(--unit) var(--double-unit);
  background-color: var(--c-neutral-200);
`;

export const VerifyPhoneBanner = () => {
  const [showVerifyPhone, setShowVerifyPhone] = useState(false);
  const { currentUser } = useCurrentUserContext();
  if (currentUser?.phoneNumberVerified) return null;
  return (
    <>
      <Root onClick={() => setShowVerifyPhone(true)}>
        <LabelM>
          <FormattedMessage
            id="Invite.VerifyPhoneBanner.content"
            defaultMessage="You need to verify your phone number to validate the referral."
          />
        </LabelM>
        <Button
          asSpan
          color="secondary"
          size="compact"
          onClick={() => setShowVerifyPhone(true)}
        >
          <FormattedMessage {...glossary.verify} />
        </Button>
      </Root>
      {showVerifyPhone && (
        <VerifyPhoneNumber onCancel={() => setShowVerifyPhone(false)} />
      )}
    </>
  );
};
